export default "__VITE_ASSET__DjOo7xa9__"